import styled from "styled-components";
import { COLORS, responsive, THEME } from "../../../../styles/constants.style";

export const CreateBulkActivityStepperWrapper = styled.div`
  background: ${COLORS.primary_light_blue1};
  border: 1px solid ${COLORS.primary_light_blue4};
  padding: 32px;

  ${responsive.MOBILE`
    padding: 16px;
  `}

  .stepper-content {
    text-align: center;
    margin-top: 40px;
    
    ${responsive.MOBILE`
      margin-top: 16px;
    `}

    .stepper-title {
      font-size: ${THEME.fontSizes[800]};
      color: ${COLORS.primary_dark_blue8};

      ${responsive.MOBILE`
        font-size: ${THEME.fontSizes[700]};
      `}
    }

    .stepper-description {
      color: ${COLORS.cirrus_black8};
      margin-top: 5px;
      font-size: ${THEME.fontSizes[400]}
    }
  }
  .MuiStepper-horizontal {
    max-width: 700px;
    margin: 0 auto;
  }
`;
